var httpBuildQuery = require('http-build-query');

export async function fapi(ks){
  // var burl = 'http://localhost/jc/index.php';
  // var burl = 'http://192.168.1.93/jc/index.php';
  var burl = "https://pajaropolitico.com/jc/index.php";

  if(!ks){
    ks = {};
  }
  ks.key = '079a963c$';

  var q = httpBuildQuery(ks);

  var url = burl + '?' + q;

  console.log('url', url);
  var r = await fetch(url);
  var j = await r.json();
  return j;
}

export async function iresults(q){
  if(!q){
    q = {};
  }
  q.action = 'buildResults';
  var r = await fapi(q);
  return r.response;
}
